module.exports = __webpack_public_path__ + "static/media/what.057108bf.ico";